import { render, staticRenderFns } from "./ResetPasswordPanel.vue?vue&type=template&id=37b722b9&"
import script from "./ResetPasswordPanel.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports